import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openPromoInfo } from '../../actions/promoInfo';
import { Promo as PromoComponent } from '../../components/Promo';
import { PromoIntro } from '../../components/PromoIntro';
import { PromoPreview } from '../../components/PromoPreview';
import { useIsMortgageBrokerBannerAvailable } from '../../hooks/useIsMortgageBrokerBannerAvailable';
import { selectBlackFridayTopPromoSubtitle } from '../../selectors/blackFriday';
import { getNewbuildingId, getPromo, getPromosForPreview } from '../../selectors/newbuilding';
import { IPromo } from '../../types/newbuilding/promos';
import { trackClickPromoBlock } from '../../utils/analytics';
import { getPromoDate, getPromoIcon, getPromoSubtitle } from '../../utils/promos';
import { PromoLink } from '../PromoLink';

export const Promo = () => {
  const dispatch = useDispatch();
  const isMortgageBrokerBannerAvailable = useIsMortgageBrokerBannerAvailable();
  const promo = useSelector(getPromo);
  const promosToPreview = useSelector(getPromosForPreview);
  const newbuildingId = useSelector(getNewbuildingId);
  const topPromoSubtitle = useSelector(selectBlackFridayTopPromoSubtitle);

  const openPromo = React.useCallback(
    (promo: IPromo) => {
      dispatch(openPromoInfo({ promo }));
      trackClickPromoBlock(promo, newbuildingId);
    },
    [newbuildingId],
  );

  const openMainPromo = React.useCallback(() => {
    openPromo(promo as IPromo);
  }, [promo, openPromo]);

  const promoDate = React.useMemo(() => getPromoDate(promo), [promo]);
  const promoIcon = React.useMemo(() => getPromoIcon(promo, true), [promo]);
  const promoSubtitle = React.useMemo(() => getPromoSubtitle(promo, topPromoSubtitle), [promo, topPromoSubtitle]);

  /* Если отображается баннер "Циан.Ипотека для профи", то скрываем блок */
  if (!promo || isMortgageBrokerBannerAvailable) {
    return null;
  }

  return (
    <PromoComponent
      promo={
        <PromoIntro
          dueDate={promoDate}
          name={promo.name}
          subtitle={promoSubtitle}
          onClick={openMainPromo}
          icon={promoIcon}
          isBlackFridayPromo={promo.isBlackFriday}
        />
      }
      link={<PromoLink />}
      previews={promosToPreview.length ? <PromoPreview promos={promosToPreview} onPromoClick={openPromo} /> : null}
    />
  );
};
